var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M7.75 11.5H10.25L11.25 7.5H7.75V5.5C7.75 4.47 7.75 3.5 9.75 3.5H11.25V0.14C10.924 0.0970001 9.693 0 8.393 0C5.678 0 3.75 1.657 3.75 4.7V7.5H0.75V11.5H3.75V20H7.75V11.5Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"12","height":"20","viewBox":"0 0 12 20","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
